export default "__VITE_ASSET__a76217d5__"